"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("../../data/interfaces");
var moment_1 = __importDefault(require("moment"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var getRulesByUserProfileType = function (rules, userProfileType) {
    var newRules;
    switch (userProfileType) {
        case interfaces_1.UserProfileType.Student:
            newRules = rules.student;
            break;
        case interfaces_1.UserProfileType.Staff:
            newRules = rules.staff;
            break;
        default:
            newRules = {};
            console.log("No rules were found for userProfileType: " + userProfileType);
            break;
    }
    return newRules;
};
exports.getRulesByUserProfileType = getRulesByUserProfileType;
var DELIMITER = "<<@>>";
exports.DELIMITER = DELIMITER;
var getPartsByDelimiter = function (value) {
    return value.split(DELIMITER);
};
exports.getPartsByDelimiter = getPartsByDelimiter;
var EASTERN_TIME_ZONE = "America/New_York";
var convertToLocalDate = function (date) {
    return moment_timezone_1.default(date).tz(EASTERN_TIME_ZONE).format("MMM D, YYYY h:mm A zz");
};
exports.convertToLocalDate = convertToLocalDate;
var convertToLocalDateFormat = function (date) { return moment_1.default(date).format("MM/DD/YYYY"); };
exports.convertToLocalDateFormat = convertToLocalDateFormat;
var formatToStringDate = function (date) { return moment_1.default(new Date(date)).format("MM/DD/YYYY HH:mm:ss"); };
exports.formatToStringDate = formatToStringDate;
var formatStandarUSDate = function (date) {
    if (!moment_1.default(date).isValid()) {
        return date ? "" + date : "";
    }
    return "" + moment_1.default(date).utc().format("MM/DD/YYYY");
};
exports.formatStandarUSDate = formatStandarUSDate;
var CHECK_LEAD_DISTRIBUTION_STAGE = {
    educationInformationIndexStage: 5,
    financingInformationIndexStage: 9
};
exports.CHECK_LEAD_DISTRIBUTION_STAGE = CHECK_LEAD_DISTRIBUTION_STAGE;
//# sourceMappingURL=data:application/json;base64,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